(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
function initRelatedProductsCarousel(sectionRoot) {
  if (!sectionRoot) return;

  const viewport = sectionRoot.querySelector('.related-products__viewport');
  const prevBtn = sectionRoot.querySelector('.related-products__btn--prev');
  const nextBtn = sectionRoot.querySelector('.related-products__btn--next');
  const firstItem = sectionRoot.querySelector('.related-products__item');

  if (!viewport || !firstItem) return;

  const getStep = () => {
    const itemWidth = firstItem.getBoundingClientRect().width;
    const grid = sectionRoot.querySelector('.related-products__grid');
    const gap = grid ? parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap || 0) : 0;
    return itemWidth + gap;
  };

  const updateButtons = () => {
    if (!prevBtn || !nextBtn) return;
    const maxScroll = viewport.scrollWidth - viewport.clientWidth;
    prevBtn.disabled = viewport.scrollLeft <= 4;
    nextBtn.disabled = viewport.scrollLeft >= maxScroll - 4;
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      viewport.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      viewport.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
    });
  }

  viewport.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);
  updateButtons();
}

function loadProductRecommendationsIntoSection(sectionId) {
  const selector = sectionId
    ? '.related-products[data-section-id="' + sectionId + '"]'
    : '.related-products';

  const productRecommendationsSection = document.querySelector(selector);
  if (!productRecommendationsSection) return;

  const request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      const container = document.createElement("div");
      container.innerHTML = request.response;
      const newSection = container.querySelector(".related-products");
     if (newSection) {
  productRecommendationsSection.innerHTML = newSection.innerHTML;
  initRelatedProductsCarousel(productRecommendationsSection);

  if (window.Wishlist && typeof window.Wishlist.initWishlist === 'function') {
    window.Wishlist.initWishlist(productRecommendationsSection);
  }
}
    }
  };
  request.send();
}

document.addEventListener("shopify:section:load", function(event) {
  const section = document.querySelector('.related-products[data-section-id="' + event.detail.sectionId + '"]');
  if (section) {
    loadProductRecommendationsIntoSection(event.detail.sectionId);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  loadProductRecommendationsIntoSection();
  const section = document.querySelector('.related-products');
  if (section) initRelatedProductsCarousel(section);
});

  } catch(e) { console.error(e); }
})();
})();
